export const getPreciseCurrentLocation = ({
  desiredAccuracy = 80,
  timeoutMs = 12000,
  maximumAge = 0,
} = {}) =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    let bestPosition = null;
    let settled = false;
    let watchId = null;

    const cleanup = () => {
      if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
      }
    };

    const finish = (position) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(position);
    };

    const fail = (error) => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(error);
    };

    const timer = window.setTimeout(() => {
      if (bestPosition) {
        finish(bestPosition);
        return;
      }

      fail(new Error("Timed out while getting current location."));
    }, timeoutMs);

    watchId = navigator.geolocation.watchPosition(
      (position) => {
        const accuracy = Number(position?.coords?.accuracy) || Number.POSITIVE_INFINITY;

        if (!bestPosition || accuracy < bestPosition.coords.accuracy) {
          bestPosition = position;
        }

        if (accuracy <= desiredAccuracy) {
          window.clearTimeout(timer);
          finish(position);
        }
      },
      (error) => {
        window.clearTimeout(timer);
        fail(error);
      },
      {
        enableHighAccuracy: true,
        timeout: timeoutMs,
        maximumAge,
      }
    );
  });
